import React from 'react';
import { LayersIcon, SearchOffIcon, Text } from '@billda/design-system';

export interface EmptyStatePlotsProps {
  isSearchResult: boolean;
}

export const EmptyStatePlots: React.FC<EmptyStatePlotsProps> = ({
  isSearchResult,
}) => {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-8 text-center">
      {isSearchResult ? (
        <SearchOffIcon
          className="mb-4 size-16 text-content-disabled"
          aria-hidden="true"
        />
      ) : (
        <LayersIcon
          className="mb-4 size-16 text-content-disabled"
          aria-hidden="true"
        />
      )}
      <Text variant="h6" color="secondary" className="mb-2">
        {isSearchResult ? 'No plots match your search' : 'No plots found'}
      </Text>
      <Text variant="body2" color="secondary">
        {isSearchResult
          ? 'Try adjusting your search terms.'
          : "This site doesn't have any plots yet."}
      </Text>
    </div>
  );
};
